<!-- VProgressLoader.vue -->
<template>
  <v-card class="progress-loader-card" flat>
    <v-card-text class="pa-4">
      <div class="text-center mb-2">
        <span class="text-h6">Carregando Notas</span>
      </div>
      <v-progress-linear
        :value="percent"
        color="primary"
        height="25"
        rounded
        background-color="grey lighten-3"
      >
        <template v-slot:default="{ value }">
          <strong>{{ Math.round(value) }}%</strong>
        </template>
      </v-progress-linear>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "EProgressLoader",
  props: {
    total: {
      type: Number,
      required: true,
    },
    loaded: {
      type: Number,
      required: true,
    },
  },
  computed: {
    percent() {
      if (this.total === 0) return 0;
      return (this.loaded / this.total) * 100;
    },
  },
};
</script>

<style scoped>
.progress-loader-card {
  max-width: 400px;
  margin: 0 auto;
}
</style>
